import React, { Component , Fragment } from "react";
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Leftnav from '../components/Leftnav';
import Pagetitle from '../components/Pagetitle';
import Appfooter from '../components/Appfooter';
import Popupchat from '../components/Popupchat';
import { postsByTag } from '../services/dummy-data';

class Badge extends Component {
    
    render() {
        return (
            <Fragment> 
                <Header />
                <Leftnav />
                <div className="main-content right-chat-active">
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left pe-0">
                            <div className="row">
                                <div className="col-xl-12">
                                    <Pagetitle title="Marcas & Influenciadores"/>
                                    <h1>FUNCIONALIDAD PRÓXIMAMENTE DISPONIBLE</h1>
                                    <div className="row ps-2 pe-1">
                                        {postsByTag.map((value , index) => (
                                        <Link to="/" key={index} className="col-md-4 col-sm-6 pe-2 ps-2">
                                            <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                                                <div className="card-body d-block w-100 p-4 text-center">
                                                    <figure className="avatar ms-auto me-auto mb-0 position-relative w90 z-index-1"><img src={`${value.owner.picture}`} alt="avater" className="float-right p-1 bg-white rounded-circle w-100" /></figure>
                                                    <div className="clearfix"></div>
                                                    <h4 className="fw-700 font-xss mt-3 mb-0">{value.owner.firstNameame} </h4>
                                                    <p className="fw-500 font-xssss text-grey-500 mt-0 mb-3">{value.owner.email}</p>
                                                    <ul className="d-flex align-items-center justify-content-center mt-1">
                                                        <li className="m-2"><h4 className="fw-700 font-sm">55.7k <span className="font-xsssss fw-500 mt-1 text-grey-500 d-block">Conecciones</span></h4></li>
                                                        <li className="m-2"><h4 className="fw-700 font-sm">10K <span className="font-xsssss fw-500 mt-1 text-grey-500 d-block">Siguiendo</span></h4></li>
                                                        <li className="m-2"><h4 className="fw-700 font-sm">15K <span className="font-xsssss fw-500 mt-1 text-grey-500 d-block">Seguidores</span></h4></li>
                                                    </ul>
                                                    <ul className="d-flex align-items-center justify-content-center mt-1">
                                                        {true ? <li className="m-1"><img src={`assets/images/challenge-medal.svg`} alt="icon" /></li> : ''}
                                                        {value.badge2 ? <li className="m-1"><img src={`assets/images/${value.badge2}`} alt="icon" /></li> : ''}
                                                        {true ? <li className="m-1"><img src={`assets/images/fast-graduate.svg`} alt="icon" /></li> : ''}
                                                        {value.badge4 ? <li className="m-1"><img src={`assets/images/${value.badge4}`} alt="icon" /></li> : ''}
                                                    </ul>
                                                    <a href="#follow" className="mt-4 p-0 btn p-2 lh-24 w100 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white">Seguir</a>
                                                </div>
                                            </div>
                                        </Link>

                                        ))}

                                        
                                    </div>
                                </div>               
                            </div>
                        </div>
                        
                    </div>
                </div>
                <Popupchat />
                <Appfooter /> 
            </Fragment>
        );
    }
}

export default Badge;